import { useContext } from "react"
import { GeoLocationContext } from "./GeoLocationContext"

export const useGeoLocation = () => {
  const values = useContext(GeoLocationContext)
  return values
}
